import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class PolicyClient extends BaseModel {
    @Expose() id = -1;
    @Expose() documentId = "";
    @Expose() documentType = "";
    @Expose() names = "";
    @Expose() firstSurname = "";
    @Expose() lastSurname = "";

    get fullName(): string {
        const firstName = this.names.includes(" ")
            ? this.names.split(" ")[0]
            : this.names;
        return `${firstName} ${firstName} ${this.lastSurname}`;
    }
}
